import { CSS } from '@grupoboticario/flora-react'

export const fieldsetCss: CSS = {
  backgroundColor: '#F2F2F2',
  border: '1px solid $medium-light-3',
  borderRadius: '10px',
  padding: '$6',
  marginBottom: '$6'
}

export const paddingBottomCss: CSS = {
  paddingBottom: '$6'
}

export const descriptionRowCss: CSS = {
  background: '#F2f2f2'
}
